module.exports = require('./helpers/bundle-url').getBundleURL('6NLDm') + "logo.c51670a8.svg";